// @flow
import api from '../api/catalog';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import { shouldFetchItemsForCatalog } from './item';

/* Action Types */
export const LOAD_CATALOG_ITEMS_FAIL = 'la/domain/catalogItems/LOAD_FAIL';
export const LOAD_CATALOG_ITEMS_REQUEST = 'la/domain/catalogItems/LOAD_REQUEST';
export const LOAD_CATALOG_ITEMS_SUCCESS = 'la/domain/catalogItems/LOAD_SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    byId: {},
    // TODO move loaded and loading to here from loaded reducer
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    let existing;

    switch (action.type) {
        case LOAD_CATALOG_ITEMS_SUCCESS:
            existing = cloneDeep(state.byId);

            if (action.payload.catalogItems) {
                action.payload.catalogItems.forEach(item => {
                    existing[item.catalogId] = { ...item };
                });
            }
            return {
                ...state,
                byId: existing,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.catalogItems;
const idSelector = (state: GlobalState, id) => id;

const byIdSelector = createSelector(stateSelector, state => state.byId);

const itemsSelector = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || {});

export const getTotalItemCount = createSelector(itemsSelector, items => items.totalCount || 0);

/* ACTION CREATORS */
const loadCatalogItems = (catalogId, cursor, page, count, itemId, buyNow) => async (dispatch, getState) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            meta: { actionTime: Date.now() },
            payload: catalogId,
            type: LOAD_CATALOG_ITEMS_REQUEST,
        });
        const response = await api.postCatalogItems({
            authToken,
            buyNow,
            catalogId,
            count,
            cursor,
            deployment,
            itemId,
            page,
        });

        return dispatch({
            meta: { actionTime: Date.now(), catalogId },
            payload: response.data,
            type: LOAD_CATALOG_ITEMS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { catalogId },
            payload: error,
            type: LOAD_CATALOG_ITEMS_FAIL,
        });
    }
};

export const fetchCatalogItemsIfNeeded = (
    catalogId: number,
    cursor?: any,
    page?: number,
    count?: number | string,
    itemId?: number,
    buyNow?: any
) => async (dispatch: Function, getState: Function) => {
    const needed = shouldFetchItemsForCatalog(getState(), catalogId, cursor, page, itemId, count);
    if (needed) {
        return dispatch(loadCatalogItems(catalogId, cursor, page, count, itemId, buyNow));
    }
    return Promise.resolve();
};
